import axios from "axios";
import { BASE_URL } from "../../helper/base-url";

export async function subscribeNewsletterService({ email, source = "footer" }) {
  try {
    return await axios.post(
      `${BASE_URL}newsletter/subscribe`,
      { email, source },
      {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-client-secret": process.env.REACT_APP_CLIENT_SECRET,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    return error.response || { status: 500, data: { message: "Network error" } };
  }
}
